import {isMobile} from '@netx/core-next/utils/browser';
import {canUseGridEditor} from '@netx/core-attribute-grid-editor';
import {currentCartIsNotEmpty} from './currentCartIsNotEmpty';

export const canEditCurrentCartAttributes = () =>
	!isMobile(false) && currentCartIsNotEmpty() && canUseGridEditor();

export default canEditCurrentCartAttributes;
